import { Banner, CTA, HorizontalWordLoop } from '@/components'
import mailer from '../../assets/images/blog/samuel.webp'
import { Fade, JackInTheBox } from "react-awesome-reveal";
import { Helmet } from 'react-helmet-async';

export const SamuelMorse = () => {

    return <>

<Helmet>
            <title>Morse Code Academy | Samuel Finley Morse</title>
            <meta name="title" content="Morse Code Academy | Samuel Finley Morse" />
            <meta
                name="description"
                content="Samuel Finley Breese Morse (1791–1872) was an American painter and inventor, best known for his role in the invention of the single-wire telegraph system and the co-development of Morse code. He made significant contributions to both the fields of communication and art."
            />

            <meta
                property="og:description"
                content="Samuel Finley Breese Morse (1791–1872) was an American painter and inventor, best known for his role in the invention of the single-wire telegraph system and the co-development of Morse code. He made significant contributions to both the fields of communication and art."
            />
            <meta property="og:image" content={mailer} />
            <meta
                property="og:title"
                content="Morse Code Academy | Samuel Finley Morse"
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://morsecodeacademy.site/blog/samuel-morse" />
        </Helmet>


        <JackInTheBox triggerOnce={true} delay={1000}>
            <Banner
                subtitle={"Learn More About"}
                title={'SAMUEL <span class="stroke white">MORSE </span>'}
                image={mailer}
            // description="Create your software design blueprint with expert software design services."
            />
        </JackInTheBox>

        <div className="">
            <div className="container">
                <div className="row pt-5 align-items-center justify-content-center justify-content-lg-start ">
                    <div className="col-lg-12 mt-lg-0 mt-3">
                        <Fade triggerOnce={true}>
                            <h3 className='text-primary'>About Samuel Finley Morse</h3>
                            <p className="text-white mt-3 ">
                                Samuel Finley Breese Morse (1791–1872) was an American painter and inventor, best known for his role in the invention of the single-wire telegraph system and the co-development of Morse code. He made significant contributions to both the fields of communication and art.
                            </p>
                        </Fade>

                        <Fade triggerOnce={true}>
                            <h3 className='text-primary mt-3'>
                                Early Life
                            </h3>
                            <p className="text-white mt-3 ">
                                Morse was born on April 27, 1791, in Charlestown, Massachusetts. He showed an early talent for art and went on to study painting in England. He became a successful portrait artist in the early part of his career, painting notable figures of his time.

                            </p>
                        </Fade>
                    </div>
                </div>
            </div>
        </div>
        <Fade triggerOnce={true} delay={100}>
            <HorizontalWordLoop title={"SAMUEL MORSE"} />
        </Fade>
        <div className="container">
            <div className="row pb-5 align-items-center justify-content-center justify-content-lg-start ">
                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                    Invention of the Telegraph
                    </h3>
                    <p className="text-white mt-3 ">
                    Morse's interest in technology began during his travels in Europe. In the 1830s, he began working on a device that could transmit messages over long distances using electrical signals. Together with Leonard Gale and Alfred Vail, Morse developed the telegraph system, which used electrical pulses to transmit messages encoded in dots and dashes, now known as Morse code.
                    </p>
                </Fade>

                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                    Legacy
                    </h3>
                    <p className="text-white mt-3 ">
                    The first successful demonstration of the telegraph occurred in 1844 when Morse sent the famous message "What hath God wrought" from Washington, D.C., to Baltimore, Maryland. His invention revolutionized communication, making it possible to send messages quickly across great distances.
                    </p>

                    <p className="text-white mt-3 ">
                    Samuel Morse's contributions earned him widespread recognition, and he is remembered as a pioneer in the field of communication technology.
                    </p>

                </Fade>
            </div>
        </div>
        <CTA
            title={"Bridging <span class='stroke'>Ideas</span><br>To <span class='stroke '>Solutions</span>"}
            description={"Are you ready to start a new software development project? Work with our team of software designers and developers. It’s never too early, or too late, to bring your idea to life."} />


    </>

}
